import { Component, OnInit, Inject, PLATFORM_ID, HostListener } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Router, ActivatedRoute, Params, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { FuncionService } from '../../servicios/funcion.service';
import { Base64, Metatags } from '../../utilidades/utilidades';

import * as $ from 'jquery';

@Component({
	selector: 'app-tienda',
	templateUrl: './tienda.component.html',
	styleUrls: ['./tienda.component.css']
})
export class TiendaComponent implements OnInit {
	
	esTiendaHome: boolean = true;
	marca: string = "";

	showFiltoCategoria:boolean = true;
	showFiltoPrecio:boolean = true;
	showFiltoMarca:boolean = true;
	isMovil:boolean = false;
	mostrarFiltrosMovil:boolean = !true;


	listaFiltros:any = {categorias:[], marcas:[], precios:"", buscar:""};

	currentBanner:any = {
		id:0,
		cantidad:0,
		imagenMovil:"assets/images/categorias/categoriasM.webp",
		imagenPC:"assets/images/categorias/categorias.webp",
		titulo:"Pawerful PetShop"
	};

	listaBanners:any = [{
		id:0,
		cantidad:0,
		imagenMovil:"assets/images/categorias/categoriasM.webp",
		imagenPC:"assets/images/categorias/categorias.webp",
		titulo:"Pawerful PetShop"
	},{
		id:87,
		cantidad:0,
		imagenMovil:"assets/images/categorias/acuarioM.png",
		imagenPC:"assets/images/categorias/acuario.png",
		titulo:"Pawerful PetShop - Acuario"
	},{
		id:51,
		cantidad:0,
		imagenMovil:"assets/images/categorias/gatosM.png",
		imagenPC:"assets/images/categorias/gatos.png",
		titulo:"Pawerful PetShop - Gatos"
	},{
		id:89,
		cantidad:0,
		imagenMovil:"assets/images/categorias/reptilesM.png",
		imagenPC:"assets/images/categorias/reptiles.png",
		titulo:"Pawerful PetShop - Reptiles"
	},{
		id:86,
		cantidad:0,
		imagenMovil:"assets/images/categorias/roedoresM.png",
		imagenPC:"assets/images/categorias/roedores.png",
		titulo:"Pawerful PetShop - Roedores"
	},{
		id:2,
		cantidad:0,
		imagenMovil:"assets/images/categorias/perrosM.png",
		imagenPC:"assets/images/categorias/perros.png",
		titulo:"Pawerful PetShop - Perros"
	},{
		id:88,
		cantidad:0,
		imagenMovil:"assets/images/categorias/avesM.png",
		imagenPC:"assets/images/categorias/aves.png",
		titulo:"Pawerful PetShop - Aves"
	},{
		id:90,
		cantidad:0,
		imagenMovil:"assets/images/categorias/petloversM.png",
		imagenPC:"assets/images/categorias/petlovers.png",
		titulo:"Pawerful PetShop - Pet Lovers"
	}];

	listaRangos: any = [{
  		id:"0-199",
  		inicio:1,
  		fin:199,
  		seleccionado:false
  	},{
  		id:"200-499",
  		inicio:200,
  		fin:499,
  		seleccionado:false
  	},{
  		id:"500-999",
  		inicio:500,
  		fin:999,
  		seleccionado:false
  	},{
  		id:"1000-1999",
  		inicio:1000,
  		fin:1999,
  		seleccionado:false
  	},{
  		id:"2000-2999",
  		inicio:2000,
  		fin:2999,
  		seleccionado:false
  	},{
  		id:"3000-1000000",
  		inicio:3000,
  		fin:1000000,
  		seleccionado:false
  	}];

	listaCategorias:any;
	filtrosTienda:any;
	listaMarcas:any;
	listaProductos:any = [];
	totalProductos:number;
	tituloOrden:string = "Ordenar por...";

	txtMarcas:string = "";

	initPage:boolean = true;
	isLoading:boolean = false;

	newParams:Params = {};

	showFiltros:boolean = false;

	listaOrdenamiento:any = [{
		id:1, nombre:"Mayor a menor precio"
	},{
		id:2, nombre:"Menor a mayor precio"
	},{
		id:3, nombre:"Más vendidos"
	},{
		id:4, nombre:"Más populares"
	}];
	paginacion:any = {
		max:20, offset:0, orden:{ id:4, nombre:"Más populares" }, incio:0, fin:0, totalPaginas:0, currentPage:1
	};


	@HostListener('window:resize', ['$event'])
	onResize(event) {
	  	this.fnViewResize( event.target.innerWidth );
	}

	changeSource(event) {
		this.currentBanner = {
			id:0,
			cantidad:0,
			imagenMovil:"assets/images/categorias/categoriasM.webp",
			imagenPC:"assets/images/categorias/categorias.webp",
			titulo:"Pawerful PetShop"
		};
	}

	fnViewResize( anchoWindow ){
		if( anchoWindow > 1024 ){
  			this.showFiltoCategoria = true;
			this.showFiltoPrecio = true;
			this.showFiltoMarca = true;
			this.isMovil = false;
  		}else{
  			this.showFiltoCategoria = false;
			this.showFiltoPrecio = false;
			this.showFiltoMarca = false;
			this.isMovil = true;
  		}
	}

	fnMostrarFiltros( newOpcion, newEvent ){
		var newElement;
		if( newOpcion === 1 ){
			this.showFiltoCategoria = !this.showFiltoCategoria;
			this.showFiltoPrecio = false;
		this.showFiltoMarca = false;
			newElement = $(".filtro-content-categorias");
		}else if( newOpcion === 2 ){
			this.showFiltoPrecio = !this.showFiltoPrecio;
			this.showFiltoCategoria = false;
			this.showFiltoMarca = false;
			newElement = $(".filtro-content-precios");
		}else if( newOpcion === 3 ){
			this.showFiltoCategoria = false;
			this.showFiltoPrecio = false;
			this.showFiltoMarca = !this.showFiltoMarca;
			newElement = $(".filtro-content-marcas");
		}
		newElement.css({
			top:( $(newEvent.target).height() + 17 ),
			width:( parseInt($(newEvent.target).width()) + 22 )
		});
		$(newElement).find("section").scrollTop( 0 );
	}
	fnMostrarFiltroMovil(){
		this.mostrarFiltrosMovil = !this.mostrarFiltrosMovil;
	}

	/* 	INICIO -> FUNCIONES JQUERY */
	fnAccionFiltros(){
		this.showFiltros = !this.showFiltros;
	}
	
	/* 	FIN -> FUNCIONES JQUERY */

	fnCheckCategorias(newCategoria:any, newParams){
		let newEncoder = new Base64();
		if( Array.isArray( newParams.categorias ) ){
			if( newParams.categorias.includes(`${newEncoder.encode(`${newCategoria.id}`)}-${newCategoria.alias}`) ){
				return true;
			}
		}else{
			if( newParams.categorias ===  `${newEncoder.encode(`${newCategoria.id}`)}-${newCategoria.alias}` ){
				return true;
			}
		}
	}

	fnCheckMarcas(newMarca:any){
		let newEncoder = new Base64();
		if( Array.isArray( this.newParams.marcas ) ){
			if( this.newParams.marcas.includes(`${newEncoder.encode(`${newMarca.id}`)}-${newMarca.alias}`) ){
				return true;
			}
		}else{
			if( this.newParams.marcas ===  `${newEncoder.encode(`${newMarca.id}`)}-${newMarca.alias}` ){
				return true;
			}
		}
	}

	constructor( 
		private newFuncionService:FuncionService, 
		private newActivatedRoute:ActivatedRoute, 
		private newRouter:Router,
		private newTitle: Title,
		@Inject(PLATFORM_ID) private platformId: Object,
		) {
		this.newActivatedRoute.paramMap.subscribe( (responseParams:any) => {
			console.log("this.newActivatedRoute.paramMap.subscribe -> responseParams.params", responseParams.params);
			if( responseParams.params.aliasMarca ){
				this.esTiendaHome = false;
				this.marca = responseParams.params.aliasMarca;
				this.newFuncionService.fnInformacionMarca( this.marca ).subscribe((resp:any) => {
					this.listaBanners[0].titulo = resp.marca.titulo;
					this.listaBanners[0].imagenPC = resp.marca.landscape;
					this.listaBanners[0].imagenMovil = resp.marca.portrait;
					this.listaBanners[0].imagenRender = resp.marca.landscape;
					this.newTitle.setTitle(resp.marca.titulo);
					let newMetatags:Metatags ={
						title:resp.marca.titulo,
						description:resp.marca.descripcion,
						image: resp.marca.portrait,
						url:`https://www.pawerful.com${ this.newRouter.url }`,
						robots:'index, follow',
						keywords:"Alimento, mascotas, perros, gatos, juguetes, royal canin, Hill's, Nupec, Science diet, envío exprés, envío express, mascotas CDMX, camas, roedores, resptiles, aves, peces, transportadoras, antipulgas, desparacitante, satiety, support, recovery, lata, weight control, Royal weight control, hidrolized, carnaza, premios para perro, smartbones, petaco, arenero, arbol para gato, petco, +kota, mascotas, la tienda de frida, huellas, animalia, servicio a domicilio, mascotas CDMX, adopciones, feline, sudadera, capa, suéter, alimento premium, alimento seco, alimento húmedo, collares, correas, feline, kitten, a/d, hills, science diet, mobility, urinary, canine, smartsticks, kong, camas para perro, camas para gato, camas para mascota, cangurera perro, óptimo, purina, platos para perro, bebederos para perro, pechera para perro, collares gato, collar, correa",
		    			language:"Spanish",
		    			type:"product.group",
		    			author:"Pawerful pet shop, S.A. de C.V."
					};

					this.newFuncionService.fnUpdateMetas( newMetatags );
					this.fnViewResize( window.innerWidth );
				});
			}else{
				this.newTitle.setTitle("Tienda Pawerful Pet Shop");
				let newMetatagsMarca:Metatags = {
					title: "Pawerful. Tienda de mascotas de México.",
					description: "La tienda online de productos para mascotas, alimentos para perros y gatos premium con entrega exprés a todo México. Accesorios, ropa, juguetes y más.",
					image: 'https://repo.ordenaris.com/pawerful/logotipos/portrait/logotipo.png',
					url:`https://www.pawerful.com${this.newRouter.url}`,
					robots:'index, follow',
					keywords: "Alimento, mascotas, perros, gatos, juguetes, royal canin, Hill's, Nupec, Science diet, envío exprés, envío express, mascotas CDMX, camas, roedores, resptiles, aves, peces, transportadoras, antipulgas, desparacitante, satiety, support, recovery, lata, weight control, Royal weight control, hidrolized, carnaza, premios para perro, smartbones, petaco, arenero, arbol para gato, petco, +kota, mascotas, la tienda de frida, huellas, animalia, servicio a domicilio, mascotas CDMX, adopciones, feline, sudadera, capa, suéter, alimento premium, alimento seco, alimento húmedo, collares, correas, feline, kitten, a/d, hills, science diet, mobility, urinary, canine, smartsticks, kong, camas para perro, camas para gato, camas para mascota, cangurera perro, óptimo, purina, platos para perro, bebederos para perro, pechera para perro, collares gato, collar, correa",
					language:"Spanish",
					type:"website",
					author:"Pawerful pet shop, S.A. de C.V."
				};
				this.newFuncionService.fnUpdateMetas( newMetatagsMarca );
			}
		} );
	}

	fnBuscarCategoria( newCategoria ){
		this.listaCategorias.forEach( (newCategoria1:any)=>{
			if( newCategoria.id ===  newCategoria1.id ){
				newCategoria1.productos = newCategoria.productos;
			}else{
				if( newCategoria1.subcategorias ){
					newCategoria1.subcategorias.forEach( (newCategoria2:any)=>{
						if( newCategoria.id ===  newCategoria2.id ){
							newCategoria2.productos = newCategoria.productos;
						}else{
							if( newCategoria2.subcategorias ){
								newCategoria2.subcategorias.forEach( (newCategoria3:any)=>{
									if( newCategoria.id ===  newCategoria3.id ){
										newCategoria3.productos = newCategoria.productos;
									}
								})	
							}
						}
					})	
				}
			}
		})

	}

	ngOnInit() {
		setTimeout( ()=>{
			if (isPlatformBrowser(this.platformId)) {
	  			this.fnViewResize( window.innerWidth );
	      	}

			this.newFuncionService.listaCategorias().subscribe( (listaCategorias:any) =>{
				if( listaCategorias.length > 0 ){
					this.listaCategorias = listaCategorias;
					this.newActivatedRoute.queryParams.subscribe(params => {
						if( params.categorias ){
							this.listaCategorias.forEach( (newCategoria:any) => {
								newCategoria.seleccionado = false;
								if( this.fnCheckCategorias(newCategoria, params) ){
									newCategoria.seleccionado = true;
								}
								if( newCategoria.subcategorias ){
									newCategoria.subcategorias.forEach( (newSubcategoria:any) =>{
										newSubcategoria.seleccionado = false;
										if( this.fnCheckCategorias(newSubcategoria, params) ){
											newSubcategoria.seleccionado = true;
											newCategoria.seleccionado = true;
										}
										if( newSubcategoria.subcategorias ){
											newSubcategoria.subcategorias.forEach( (newOtherCategoria:any) =>{
												newOtherCategoria.seleccionado = false;
												if( this.fnCheckCategorias( newOtherCategoria, params ) ){
													newOtherCategoria.seleccionado = true;
													newSubcategoria.seleccionado = true;
													newCategoria.seleccionado = true;
												}
											});
										}
									});
								}
							});
						}
					})
				}
			});

			
			function compare(a, b) {
				const bandA = a.productos;
				const bandB = b.productos;
				let comparison = 0;
				if (bandA > bandB) {
					comparison = 1;
				} else if (bandA < bandB) {
					comparison = -1;
				}
				return comparison;
			}


			this.newFuncionService.fnCategoriasTienda(this.marca).subscribe( (response:any) =>{
				if( response.success ){
					response.lista.forEach( (newCategoria1:any)=>{
						this.fnBuscarCategoria( newCategoria1 );
						newCategoria1.subcategorias.forEach( (newCategoria2:any)=>{
							this.fnBuscarCategoria( newCategoria2 );
							newCategoria1.subcategorias.forEach( (newCategoria3:any)=>{
								this.fnBuscarCategoria( newCategoria3 );
							})	
						})
					});
				}
			});
			
			if( this.esTiendaHome ) {
				this.newFuncionService.fnMarcasTienda()
				.subscribe( (response:any) => {
					if(	response.success ){
						this.listaMarcas = response.lista;
	
						if( this.newParams.marcas ){
							this.listaMarcas.forEach( (newMarca:any) => {
								if( this.fnCheckMarcas(newMarca) ){
									newMarca.seleccionado = true;
								}
							});
						}
					}
				});
			}

			this.newActivatedRoute.queryParams.subscribe(params => {
				this.paginacion = { max:20, offset:0, orden:{ id:4, nombre:"Más populares" }, incio:0, fin:0, totalPaginas:0, currentPage:1 };
				if( params.buscar ){
					this.listaFiltros.buscar = params.buscar;
					this.fnUnsetCheckCategorias();
				}else{
					this.listaFiltros.buscar = "";
					if( params.categorias ){
						this.listaFiltros.categorias = params.categorias;
					}
					if( params.marcas ){
						this.listaFiltros.marcas = params.marcas;
					}
					if( params.precios ){
						this.listaFiltros.precios = params.precios;
					}
				}

				if( params.precios ){
					if( typeof params.precios === 'string' ) {
						let precios = params.precios.split( "-" );
						let precioInicial = this.listaRangos.filter( item => item.inicio == precios[0] );
						let precioFinal = this.listaRangos.filter( item => item.fin == precios[1] );
						precioInicial.forEach(element => {
							element.seleccionado = true
						});
						precioFinal.forEach(element => {
							element.seleccionado = true
						});
					}
				}
				this.fnUpdateUrl2(false);
			});

		},1000);

	}

	fnUnsetCheckCategorias(){
		this.listaCategorias.forEach( (newCategoria:any) => {
			newCategoria.seleccionado = false;
			if( newCategoria.subcategorias ){
				newCategoria.subcategorias.forEach( (newSubcategoria:any) =>{
					newSubcategoria.seleccionado = false;
					if( newSubcategoria.subcategorias ){
						newSubcategoria.subcategorias.forEach( (newOtherCategoria:any) =>{
							newOtherCategoria.seleccionado = false;
						});
					}
				});
			}
		});
	}

	fnUpdateOrden( newOrden ){
		this.paginacion.orden = newOrden;
		this.fnCargarProductos();
	}

	fnPaginarProductos( newPagina ){
		this.paginacion.currentPage = newPagina;
		if( parseInt(newPagina) === 1 ){
			this.paginacion.offset = 0;
		}else{
			this.paginacion.offset = ( this.paginacion.max * ( newPagina - 1 ));
		}
		this.fnCargarProductos();
	}

	fnErrorPaginador( newError ){
		this.newFuncionService.setNewAlerta( newError );
	}

	fnCargarProductos(){
		if (isPlatformBrowser(this.platformId)) {
			window.scroll(0,0);
	    }
		let newRequest = { filtros:this.newParams, paginacion: this.paginacion, marca: this.marca };
		this.isLoading = true;
		this.newFuncionService.setNewMensaje("Cargando productos...");
		this.newFuncionService.fnProductosTienda( newRequest )
		.subscribe( (responsex:any) => {
			this.initPage = false;
			// this.newFuncionService.setNewMensaje(null);
			// this.listaProductos = [];
			if( responsex.success ){
				
				this.newFuncionService.fnActualizarCantidadesFiltros( newRequest )
				.subscribe( (response:any)=>{
					if( response.success ){
						this.listaCategorias.forEach( (newCategoria:any) => {
							var categoria = response.categorias.find(x => x.id === newCategoria.id);
							if(categoria){
								newCategoria.productos = categoria.productos;

								if( newCategoria.subcategorias ){
									newCategoria.subcategorias.forEach( (newSubcategoria:any) =>{
										
										var subcategoria = categoria.subcategorias.find(x => x.id === newSubcategoria.id);
										if(subcategoria){
											newSubcategoria.productos = subcategoria.productos;

											if( newSubcategoria.subcategorias ){
												newSubcategoria.subcategorias.forEach( (newOtherCategoria:any) =>{
													
													var othercategoria = subcategoria.subcategorias.find(x => x.id === newOtherCategoria.id);
													if(othercategoria){
														newOtherCategoria.productos = othercategoria.productos;
													}
													
												});
											}

										}

									});
								}

							}
						});
						if( this.esTiendaHome ) {
							response.marcas.forEach( (marca:any)=>{
								if( this.listaMarcas ) {
									var newMarca = this.listaMarcas.find(x => x.id === marca.id);
									newMarca.productos = marca.productos;
								}
							} );
						}
					}
					this.listaProductos = [];
					this.isLoading = false;
					this.newFuncionService.setNewMensaje(null);
					this.listaProductos = responsex.lista;
					this.totalProductos = responsex.total;
	
					this.paginacion.inicio = ( this.paginacion.offset + 1 );
					this.paginacion.fin = ( this.paginacion.offset + this.listaProductos.length );
					this.paginacion.totalPaginas = Math.ceil(this.totalProductos / this.paginacion.max);
				} )

			}else{
				this.listaProductos = [];
				this.newFuncionService.setNewMensaje(null);
				this.isLoading = false;
			}
		});
	}

	/* 	INICIO -> FUNCIONES FILTROS */
	fnSeleccionCategoriaMovil( newCategoria ){
		newCategoria.seleccionado = !newCategoria.seleccionado;
		if( !newCategoria.seleccionado ){
			if( newCategoria.subcategorias ){
				newCategoria.subcategorias.forEach(function( newSubCategoria ){
					newSubCategoria.seleccionado = false;
					if( newSubCategoria.subcategorias ){
						newSubCategoria.subcategorias.forEach(function( newOtherSubCategoria ){
							newOtherSubCategoria.seleccionado = false;
						});
					}
				});
			}
		}
	}
	fnSeleccionCategoria( newCategoria:any ){
		newCategoria.seleccionado = !newCategoria.seleccionado;
		if( !newCategoria.seleccionado ){
			if( newCategoria.subcategorias ){
				newCategoria.subcategorias.forEach(function( newSubCategoria ){
					newSubCategoria.seleccionado = false;
					if( newSubCategoria.subcategorias ){
						newSubCategoria.subcategorias.forEach(function( newOtherSubCategoria ){
							newOtherSubCategoria.seleccionado = false;
						});
					}
				});
			}
		}
		let newListaCategorias:any = [];
		this.listaCategorias.forEach( (newItem:any) => {
			if(  newItem.seleccionado ){
				newListaCategorias.push( newItem );
			}
			if( newItem.subcategorias ){
				newItem.subcategorias.forEach( (newSubCategoria:any) => {
					if( newSubCategoria.seleccionado ){
						newListaCategorias.push( newItem );
						newListaCategorias.push( newSubCategoria );
					}
					if( newSubCategoria.subcategorias ){
						newSubCategoria.subcategorias.forEach( (newOtherCategoria:any) => {
							if( newOtherCategoria.seleccionado ){
								newListaCategorias.push( newOtherCategoria );
							}
						});
					}
				});
			}
		});
		this.listaFiltros.buscar = "";
		this.listaFiltros.categorias = newListaCategorias.filter(this.unique);
		this.fnUpdateUrl2(true);
		// this.fnUpdateUrl( newListaCategorias, 1, true );
	}

	fnSeleccionPrecioMovil( newPrecio ){
		newPrecio.seleccionado = !newPrecio.seleccionado;
	}
	fnSeleccionPrecio( newPrecio ){
		newPrecio.seleccionado = !newPrecio.seleccionado;
		var listaSeleccion = this.listaRangos.filter( newItem => newItem.seleccionado === true );
		if( listaSeleccion.length > 0 ){
			this.listaFiltros.precios = [`${listaSeleccion.first().inicio}-${listaSeleccion.last().fin}`];
			// this.fnUpdateUrl( [{ primero_min:listaSeleccion.first().inicio, segundo_max:listaSeleccion.last().fin }], 3, true );
		}else{
			this.listaFiltros.precios = "";
			// this.fnUpdateUrl( [], 3, true );
		}
		this.listaFiltros.buscar = "";
		this.fnUpdateUrl2(true);
	}

	fnSeleccionMarcaMovil( newMarca ){
		newMarca.seleccionado = !newMarca.seleccionado;
	}

	fnSeleccionMarca( newMarca:any ){
		newMarca.seleccionado = !newMarca.seleccionado;
		let listaMarcas:any = [];
		this.listaMarcas.forEach( (newItem:any) => {
			if( newItem.seleccionado ){
				listaMarcas.push( newItem );
			}
		});
		this.listaFiltros.marcas = listaMarcas;
		// this.fnUpdateUrl( listaMarcas, 2, true );
		this.listaFiltros.buscar = "";
		this.fnUpdateUrl2(true);
	}

	fnAplicarFiltros(){
		if( this.listaMarcas == undefined ) this.listaMarcas = [];
		let listaMarcas:any = [];
		this.listaMarcas.forEach( (newItem:any) => {
			if( newItem.seleccionado ){
				listaMarcas.push( newItem );
			}
		});
		let newListaCategorias:any = [];
		this.listaCategorias.forEach( (newItem:any) => {
			if(  newItem.seleccionado ){
				newListaCategorias.push( newItem );
			}
			if( newItem.subcategorias ){
				newItem.subcategorias.forEach( (newSubCategoria:any) => {
					if( newSubCategoria.seleccionado ){
						newListaCategorias.push( newItem );
						newListaCategorias.push( newSubCategoria );
					}
					if( newSubCategoria.subcategorias ){
						newSubCategoria.subcategorias.forEach( (newOtherCategoria:any) => {
							if( newOtherCategoria.seleccionado ){
								newListaCategorias.push( newOtherCategoria );
							}
						});
					}
				});
			}
		});
		var listaSeleccion = this.listaRangos.filter( newItem => newItem.seleccionado === true );
		var listaPrecios = [];
		if( listaSeleccion.length > 0 ){
			listaPrecios = [{ primero_min:listaSeleccion.first().inicio, segundo_max:listaSeleccion.last().fin }];
		}

		this.newParams = {};
		let newIterate = { categorias:[], marcas:[], busqueda:[], precios:[] };
		let newEncoder = new Base64();
		
		newListaCategorias.filter(this.unique).forEach(function( newItem ){
			newIterate.categorias.push( `${encodeURI(newEncoder.encode( `${newItem.id}` ))}-${newItem.alias}` )
		});
		listaMarcas.filter(this.unique).forEach(function( newItem ){
			newIterate.marcas.push( `${encodeURI(newEncoder.encode( `${newItem.id}` ))}-${newItem.alias}` )
		});
		listaPrecios.filter(this.unique).forEach(function( newItem ){
			newIterate.precios.push( `${newItem.primero_min}-${newItem.segundo_max}` );
		});
		if( newIterate.categorias.length > 0){
			this.newParams.categorias = newIterate.categorias.filter( this.unique );
		}
		if( newIterate.marcas.length > 0){
			this.newParams.marcas = newIterate.marcas.filter( this.unique );
		}
		if( newIterate.precios.length > 0 ){
			this.newParams.precios = newIterate.precios;
		}
		this.mostrarFiltrosMovil = false;
		this.newRouter.navigate(['.'], { relativeTo: this.newActivatedRoute, queryParams: this.newParams });
		// this.fnCargarProductos();
	}
	/* 	FIN -> FUNCIONES FILTROS */

	fnUpdateUrl2(actualizar:boolean){
		this.newParams = {};
		let newEncoder = new Base64();
		if( this.listaFiltros.buscar != "" ){
			this.newParams.buscar = this.listaFiltros.buscar;
			this.fnUnsetCheckCategorias();
		}else{
			this.currentBanner = this.listaBanners.find(newIt => newIt.id === 0);
			if( this.listaFiltros.categorias.length > 0 ){
				this.newParams.categorias = [];
				if( Array.isArray(this.listaFiltros.categorias) ){
					this.listaFiltros.categorias.forEach( (newItem:any)=>{
						
						if( newItem.id ){
							var newCurrent = this.listaBanners.find( newIt => newIt.id === parseInt(newItem.id) );
							if(newCurrent){
								if(this.currentBanner.id === 0){
									this.currentBanner = newCurrent;
								}else{
									this.currentBanner = this.listaBanners.find(newIt => newIt.id === 0);
								}
							}

							this.newParams.categorias.push( `${encodeURI(newEncoder.encode( `${newItem.id}` ))}-${newItem.alias}` );
						}else{
							var newData = decodeURI(newEncoder.decode( `${newItem.split('-')[0]}` ))
							var newCurrent = this.listaBanners.find( newIt => newIt.id === parseInt(newData) );
							if(newCurrent){
								if(this.currentBanner.id === 0){
									this.currentBanner = newCurrent;
								}else{
									this.currentBanner = this.listaBanners.find(newIt => newIt.id === 0);
								}
							}

							this.newParams.categorias.push( newItem );
						}
					});
				}else{
					var newData = decodeURI(newEncoder.decode( `${this.listaFiltros.categorias.split('-')[0]}` ))
					var newCurrent = this.listaBanners.find( newIt => newIt.id === parseInt(newData) );
					if(newCurrent){
						this.currentBanner = newCurrent;
					}
					this.newParams.categorias = [this.listaFiltros.categorias];
				}
			}
			this.fnViewResize( window.innerWidth );
			if( this.listaFiltros.marcas.length > 0 ){
				this.newParams.marcas = [];
				if( Array.isArray(this.listaFiltros.marcas) ){
					this.listaFiltros.marcas.forEach( (newItem:any)=>{
						if( newItem.id ){
							this.newParams.marcas.push( `${encodeURI(newEncoder.encode( `${newItem.id}` ))}-${newItem.alias}` );
						}else{
							this.newParams.marcas.push( newItem );
						}
					});
				}else{
					this.newParams.marcas = [this.listaFiltros.marcas];
				}
			}
			if( this.listaFiltros.precios != "" ){
				if( Array.isArray(this.listaFiltros.precios) ){
					this.newParams.precios = this.listaFiltros.precios;
				}else{
					this.newParams.precios = [this.listaFiltros.precios];
				}
			}
		}
		if( actualizar ){
			this.newRouter.navigate(['.'], { relativeTo: this.newActivatedRoute, queryParams: this.newParams });
		}else{
			this.fnCargarProductos();
		}
	}

	unique = (value, index, self) => {
		return self.indexOf(value) === index
	}

	fnBuscarProductos(){
		setTimeout( () =>{
			this.newActivatedRoute.queryParams.subscribe(params => {
				this.newParams = params;
				this.newRouter.navigate(['.'], { relativeTo: this.newActivatedRoute, queryParams: this.newParams });
				this.fnCargarProductos();
			}).unsubscribe();
		});
	}

	clearFilters() {
		this.listaFiltros = {categorias:[], marcas:[], precios:"", buscar:""};
		this.listaRangos.filter( newItem => newItem.seleccionado === true ).forEach( (item:any) =>{
			item.seleccionado = false;
		} );
		this.listaCategorias.filter( newItem => newItem.seleccionado === true ).forEach( (item:any) =>{
			item.seleccionado = false;
		} );
		this.listaMarcas.filter( newItem => newItem.seleccionado === true ).forEach( (item:any) =>{
			item.seleccionado = false;
		} );
		this.mostrarFiltrosMovil = false;
		this.fnUpdateUrl2(true);
		this.fnCargarProductos();
	}

}
